import React from 'react';
import PropTypes from 'prop-types';
import { SelectList, SelectListItem } from '@iris-platform/iris-react-ui';
import { find, propEq } from 'ramda';

const TeamSelector = ({
 teams, value, onSelect, ready 
}) => (
  <SelectList
    name="selectedTeam"
    value={value}
    onChange={(event) => {
      const teamName = event.target.value;
      const selectedTeam = find(propEq('display_name', teamName), teams);
      onSelect(selectedTeam);
    }}
    subHeaderText="Select Team"
  >
    {teams && ready
      ? teams.map(team => (
        <SelectListItem key={team.team_id} value={team.display_name}>
            {team.display_name}
          </SelectListItem>
      ))
      : 'Loading...'}
  </SelectList>
);

TeamSelector.propTypes = {
  teams: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  ready: PropTypes.bool.isRequired,
};

export default TeamSelector;
